import React from "react";

import PageContainer from "components/lib/PageContainer";
import { useParams } from "react-router-dom";
import { StoreIdParam } from "config/raven";
import { Segment } from "semantic-ui-react";
import { CreateSitemapSegment } from "components/SiteManage/Content/Sitemap/CreateSitemapSegment";
import { SubmitSitemapSegment } from "components/SiteManage/Content/Sitemap/SubmitSitemapSegment";
import { StoreBreadcrumbBuilder } from "utils/breadcrumb";
import { UserContainer } from "containers";

export const Sitemap: React.FC = () => {
  const { isAgency } = UserContainer.useContainer();
  const { storeId } = useParams<StoreIdParam>();

  return (
    <PageContainer
      header="サイトマップ設定"
      breadcrumbs={new StoreBreadcrumbBuilder(isAgency, storeId)
        .siteManagePage()
        .build("ドメイン設定")}
    >
      <Segment>
        <CreateSitemapSegment storeId={storeId} />
        <SubmitSitemapSegment storeId={storeId} />
      </Segment>
    </PageContainer>
  );
};
